import {
  IAuthState,
  REDUCER_KEY_AUTH,
} from "@rentiohq/shared-frontend/dist/redux/auth/auth.reducer";
import persistAuthReducer from "@rentiohq/shared-frontend/dist/redux/auth/auth.reducerPersist";
import contactReducer, {
  IContactState,
  REDUCER_KEY_CONTACT,
} from "@rentiohq/shared-frontend/dist/redux/contact/contact.reducer";
import countReducer, {
  ICountState,
  REDUCER_KEY_COUNT,
} from "@rentiohq/shared-frontend/dist/redux/count/count.reducer";
import featureFlagReducer, {
  IFeatureFlagState,
  REDUCER_KEY_FEATURE_FLAG,
} from "@rentiohq/shared-frontend/dist/redux/featureFlag/featureFlag.reducer";
import formReducer, {
  IFormState,
  REDUCER_KEY_FORM,
} from "@rentiohq/shared-frontend/dist/redux/form/form.reducer";
import {
  II18nState,
  REDUCER_KEY_I18N,
} from "@rentiohq/shared-frontend/dist/redux/i18n/i18n.reducer";
import persistI18nReducer from "@rentiohq/shared-frontend/dist/redux/i18n/i18n.reducerPersist";
import {
  IRequirementsState,
  REDUCER_KEY_REQUIREMENTS,
} from "@rentiohq/shared-frontend/dist/redux/requirements/requirements.reducer";
import persistRequirementsReducer from "@rentiohq/shared-frontend/dist/redux/requirements/requirements.reducerPersist";
import {
  REDUCER_KEY_BANK_ACCOUNT,
  bankAccountModule,
} from "@rentiohq/shared-frontend/dist/reduxV2/bankAccount";
import {
  REDUCER_KEY_PAYMENT_REQUESTS,
  paymentRequestModule,
} from "@rentiohq/shared-frontend/dist/reduxV2/paymentRequest";
import {
  REDUCER_KEY_PROPERTY as REDUCER_KEY_PROPERTY_V2,
  propertyModule,
} from "@rentiohq/shared-frontend/dist/reduxV2/property";
import { combineReducers } from "redux";

export interface IRootState {
  [REDUCER_KEY_AUTH]: IAuthState;
  [REDUCER_KEY_BANK_ACCOUNT]: typeof bankAccountModule.reducerState;
  [REDUCER_KEY_CONTACT]: IContactState;
  [REDUCER_KEY_COUNT]: ICountState;
  [REDUCER_KEY_FEATURE_FLAG]: IFeatureFlagState;
  [REDUCER_KEY_FORM]: IFormState;
  [REDUCER_KEY_I18N]: II18nState;
  [REDUCER_KEY_PAYMENT_REQUESTS]: typeof paymentRequestModule.reducerState;
  [REDUCER_KEY_PROPERTY_V2]: typeof propertyModule.reducerState;
  [REDUCER_KEY_REQUIREMENTS]: IRequirementsState;
}

// eslint-disable-next-line import/no-default-export
export default combineReducers({
  [REDUCER_KEY_AUTH]: persistAuthReducer,
  [REDUCER_KEY_BANK_ACCOUNT]: bankAccountModule.reducer,
  [REDUCER_KEY_CONTACT]: contactReducer,
  [REDUCER_KEY_COUNT]: countReducer,
  [REDUCER_KEY_FEATURE_FLAG]: featureFlagReducer,
  [REDUCER_KEY_FORM]: formReducer,
  [REDUCER_KEY_I18N]: persistI18nReducer,
  [REDUCER_KEY_PAYMENT_REQUESTS]: paymentRequestModule.reducer,
  [REDUCER_KEY_PROPERTY_V2]: propertyModule.reducer,
  [REDUCER_KEY_REQUIREMENTS]: persistRequirementsReducer,
});
